
export function sendMetric(endpoint: string, body: string) {
    (navigator.sendBeacon && navigator.sendBeacon(endpoint, body)) ||
    fetch(endpoint, {body, method: 'POST', keepalive: true});
}
